import { AlertTriangle } from "@untitledui/icons";
import { useDeleteCohortRule } from "@/api/cohort-rules";
import { Button } from "@/components/base/buttons/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface DeleteRuleDialogProps {
  target: { ruleId: string; name: string } | undefined;
  onClose: () => void;
  onCohortsChanged: () => void;
}

export function DeleteRuleDialog({ target, onClose, onCohortsChanged }: DeleteRuleDialogProps) {
  const deleteRule = useDeleteCohortRule();

  const handleDelete = async () => {
    if (!target) return;
    await deleteRule.mutateAsync(target.ruleId);
    onCohortsChanged();
    onClose();
  };

  return (
    <Dialog open={!!target} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Rule</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete <strong>{target?.name}</strong>? Creators only assigned by this rule will
            lose the cohort. This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-start gap-2.5 rounded-md bg-utility-error-50 border border-utility-error-200 px-3 py-2.5">
          <AlertTriangle className="w-4 h-4 text-utility-error-600 shrink-0 mt-0.5" />
          <p className="text-xs text-utility-error-700">
            Creators still matching another active rule stay in the cohort.
          </p>
        </div>
        <DialogFooter>
          <Button color="secondary" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button color="primary-destructive" size="sm" onClick={handleDelete} isLoading={deleteRule.isPending}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
